export const removeConfigurationHash = () => history.pushState('', document.title, window.location.pathname + window.location.search);
